<template>
  <div class="animated fadeIn">
    <b-row class="justify-content-center" v-show="showList">
        <b-col xl="6" lg="8">
          <b-card >
            <div slot="header">Exchange Rate
              <div class="card-header-actions">
                <b-button variant="btn btn-primary mr-1" @click="add">Add</b-button>
                <button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
              </div>
            </div>
            <b-row no-gutters >
              <b-col lg="7">
                  <b-input-group >
                      <b-input-group-prepend><span class="pt-2 mr-1">Period</span></b-input-group-prepend>
                      <vue-monthly-picker style="width:333px;" v-model="filter.period"  dateFormat="MMMM YYYY" :monthLabels="monthLabels" ></vue-monthly-picker>
                  </b-input-group>
              </b-col>
              <b-col lg="5">
                  <b-input-group >
                      <b-input-group-prepend><span class="pt-2 mr-1">From Currency</span></b-input-group-prepend>
                      <b-form-input v-model="filter.valasfr" @keyup.13.native="refresh()"></b-form-input>
                      <b-button class="btn btn-success ml-1" @click="refresh()" > <i class="fa fa-refresh"></i> Apply Filter</b-button>
                      <!-- <b-button class="btn btn-secondary mr-1" @click="clearFilter()" > <i class="fa fa-eraser"></i>Clear</b-button> -->
                  </b-input-group>
              </b-col>
            </b-row>

            <b-table
              class="mb-0"
              ref="table"
              outlined  responsive hover small
              style="font-size:smaller;" 
              :items="data"
              :fields="tblFields"
              :current-page="tblData.page"
              :per-page="tblData.limit"
              :sort-by.sync="tblData.sortBy"
              :sort-desc.sync="tblData.sortDesc"
              @row-clicked="rowClicked"
            >
              <template v-slot:cell(tanggal)="data">
                {{data.item.tanggal | moment("DD MMM YYYY") }}
              </template>
              <template v-slot:cell(valasto)="data">
                {{data.item.valasto}} &nbsp;
                {{data.item.nilaitukar | numFormat('0,0.00')}}
              </template>

              <template v-slot:cell(action)="data">
                <div class="text-center">
                <a href="javascript:void(0)" @click.stop="edit(data.item)">
                  <i class="fa fa-pencil"></i>
                </a>
                |
                <a href="javascript:void(0)" class="text-danger" @click.stop="deleteConfirm(data.item)">
                  <i class="fa fa-trash"></i>
                </a>
                </div>
              </template>
            </b-table>
            <b-row class="mt-2">
              <b-col cols="4">
                <div>
                  Showing {{(tblData.page - 1) * tblData.limit + 1}}
                  to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
                  of {{tblData.total}} entries
                </div>
              </b-col>
              <b-col cols="3" >
                  <b-input-group >
                      <b-input-group-prepend><span class="pt-1 mr-2">Limit per page</span></b-input-group-prepend>
                      <b-form-select :options="[10, 20, 30, 50, 70, 90, 120]" :plain="true" v-model="tblData.limit" class="mr-2" size="sm" style="width:80px;"/>
                  </b-input-group>
              </b-col>        
              <b-col cols="5">            
                <b-pagination
                  align="right"
                  :total-rows="tblData.total"
                  :per-page="tblData.limit"
                  v-model="tblData.page"
                ></b-pagination>
              </b-col>
            </b-row>

            <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
              <p class="mb-1">1 record is about to be permanently deleted</p>
              <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
            </b-modal>
          </b-card>
        </b-col>
    </b-row>
    <b-row class="justify-content-center" v-if="showForm">
      <b-col md="7" lg="6">
        <b-card >
          <div slot="header">Exchange Rate - Add/Edit Form 
          </div>
                <b-input-group >
                    <b-input-group-prepend><label>Date</label></b-input-group-prepend>
                  <b-form-input v-model="frmdata.tanggal" :state="!$v.frmdata.tanggal.$error" type="date" ></b-form-input>
                </b-input-group>
                <b-input-group >
                    <b-input-group-prepend><label>Foreign Currency (FCY)</label></b-input-group-prepend>
                    <b-form-select class="input-group-text" v-model="frmdata.valasfr" :plain="true" :options="currency" :state="!$v.frmdata.valasfr.$error"></b-form-select>
                </b-input-group>
                <b-input-group >
                    <b-input-group-prepend><label>Local Currency (LCY)</label></b-input-group-prepend>
                    <b-form-select class="input-group-text" v-model="frmdata.valasto" :plain="true" :options="currency" :state="!$v.frmdata.valasto.$error"></b-form-select>
                </b-input-group>
                <b-input-group >
                    <b-input-group-prepend><label>Exchange Rate </label></b-input-group-prepend>
                    <my-number v-model="frmdata.nilaitukar" :state="!$v.frmdata.nilaitukar.$error" class="form-control text-right" separator="," :precision="2"></my-number>
                </b-input-group>

            <div slot="footer" style="text-align:center;">
              <button class="btn btn-primary mr-1" @click="save()">
                <i class="fa fa-save"></i> Save
              </button>
             <b-button variant="secondary" class="mr-1" @click="closeFrm()" > <i class="fa fa-close"></i> Close Form</b-button>
            </div>
        </b-card>
        </b-col>
    </b-row>
  </div>
</template>
<style lang="scss">
    .input-group {
        padding-bottom:2px;
        .input-group-prepend {
            label {
                padding-top: 5px;
                padding-right: 5px;
                width: 160px;
            }
        }
    }
</style>


<script>
import toastr from "mini-toastr";
import moment from 'moment';
import crud from "../../apis/crud";
import dropdown from "../../data/dropdown";
import myNumber from "../../components/my-number";
import VueMonthlyPicker from 'vue-monthly-picker';
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

toastr.init();

export default {
  mixins: [validationMixin],
  validations: {
    frmdata: {
        tanggal: { required },
        valasfr: { required },
        valasto: { required },
        nilaitukar: { required },
    },
  }, 
  data() {
    return {
      filter:{ valasfr:'', period:moment(this.$store.state.user.tglaktif, 'YYYY-MM-DD').endOf('month')},
      showDelConfirm: false,
      showList:true,
      showForm:false,
      monthLabels:dropdown.monthLabels,
      currency:[{value:'IDR',text:'IDR'}],
      frmdata:{tanggal: '',valasfr:'', valasto:'', nilaitukar:0 },
      tblData: {
        tablename:'exchangerate',
        page: 1,
        limit: 15,
        total: 0,
        sortBy: 'tanggal',
        sortDesc: true
      },
    };
  },
  components:{myNumber, VueMonthlyPicker},
  computed: {
    tblFields(){
      const fields=[
          {
            key: "tanggal",
            label: "Date",
            sortable: true
          },
          {
            key: "valasfr",
            label: "From",
            sortable: true
          },
          {
            key: "valasto",
            label: "Into",
            thClass: "text-center",
            tdClass: "text-right",
            thStyle: "width:150px",
            sortable: true
          },
          {
            key: "action",
            label: "Action",
            thStyle: "width:100px",
            thClass: "text-center",
          }          
        ];
      return fields;
    },
    invalidFormdata() {
      this.$v.frmdata.$touch();
      return this.$v.frmdata.$invalid;
    },
  },
  created: async function(){
      this.currency = await crud.currency();
      this.$watch('filter.period', function(newVal) {
          setTimeout(() => {
              this.refresh();                
          }, 100);
      });            

  },  
  methods: {
    data: async function(ctx) {
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
      this.tblData.customQuery='';
      this.filter.periode = (this.filter.period) ? moment(this.filter.period).format('YYYYMM') : '';
      let str='';
      if (this.filter.valasfr){
        str = 'valasfr=%' + encodeURIComponent(this.filter.valasfr)+'%';
      }
      if (this.filter.periode){
        str += str ? '&' : '';
        str = str + 'periode=' + encodeURIComponent(this.filter.periode)+'%';
      }
      this.tblData.customQuery=str;

      const list = await crud.list(this.tblData);      
      return list;
    },
    refresh(ctx) {
      if (this.$refs.table) this.$refs.table.refresh();
    },
    clearFilter(ctx) {
        this.filter.period= '';
        this.filter.valasfr= '';
        this.refresh();
    },    
    add: function(data) {
        for (var key in this.frmdata) {
            this.frmdata[key] = '';
        }
      this.showForm=true;
      this.showList=false;
    },
    edit: async function(data) {
      this.model=data;
        for (var key in this.frmdata) {
            this.frmdata[key] = '';
        }
        for (var key in this.model) {
            this.frmdata[key] = this.model[key];
        }
      this.frmdata.idlama = data.tukarkey;
      this.showForm=true;
      this.showList=false;

    },
    save: async function (callback) {
          if (this.invalidFormdata) {
              console.log('validation : ', this.$v.frmdata);
              console.log('frmdata : ',this.frmdata);
              toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
        } else {
            try {
              if (this.frmdata.idlama) {
                await crud.update(
                     {tablename:'exchangerate', 
                     key:this.frmdata.idlama, 
                     data:{
                        tanggal:moment(this.frmdata.tanggal).format('YYYY-MM-DD'), 
                        valasfr:this.frmdata.valasfr, 
                        valasto:this.frmdata.valasto,
                        nilaitukar:this.frmdata.nilaitukar}
                      });
              } else {
                await crud.insert(
                  { tablename:'exchangerate',                      
                     data:{
                        tanggal:moment(this.frmdata.tanggal).format('YYYY-MM-DD'), 
                        valasfr:this.frmdata.valasfr, 
                        valasto:this.frmdata.valasto,
                        nilaitukar:this.frmdata.nilaitukar}
                  });
              }
              setTimeout(() => {
                  this.refresh();              
              }, 100);       
              this.closeFrm();              
            } catch (error) {
                if (error.message) {
                    toastr.error(error.message);
                } else {
                    toastr.error(JSON.stringify(error));
                }              
            }
        }
    },    
    deleteConfirm(item) {
      this.model = item;
      this.showDelConfirm = true;
    },
    deleteData: async function() {
      await crud.remove({tablename:'exchangerate', key:this.model.tukarkey});
      this.refresh();
    },
    rowClicked(record, index) {
      if ((this.model) && (this.model._rowVariant)) {
          delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant= 'info';
      this.$forceUpdate();
    },
    closeFrm(){
      this.showForm=false;
      this.showList=true;
    },    
    close(){
      router.push("home");
    },    
  }
};
</script>
